const sanitizeInputRestProps = ({
    afterSubmit,
    allowEmpty,
    allowNull,
    alwaysOn,
    basePath,
    beforeSubmit,
    component,
    data,
    defaultValue,
    error,
    format,
    formatOnBlur,
    formClassName,
    initialValue,
    initializeForm,
    input,
    isEqual,
    isRequired,
    label,
    limitChoicesToValue,
    locale,
    meta,
    multiple,
    name,
    options,
    optionText,
    optionValue,
    parse,
    record,
    ref,
    render,
    resource,
    source,
    submitError,
    subscription,
    textAlign,
    translate,
    translateChoice,
    type,
    validate,
    validateFields,
    value,
    ...rest
}: any) => rest;

export default sanitizeInputRestProps;